// Gravity Forms

// Add read only fields

const setReadonly = inputs => {
	if (inputs) {
		setTimeout(function() {
			[...inputs].forEach(function(input) {
				input.setAttribute('readonly', 'readonly');
			});
		}, 10);
	}
};

// const setRichTextTitle = rtfs => {
// 	if (rtfs) {
// 		setTimeout(function() {
// 			[...rtfs].forEach(function(rtf) {
// 				// get field id for label
// 				const label = rtf.previousSibling;
// 				const labelForText = label.getAttribute('for');
// 				const labelID = labelForText + '_label';

// 				rtf.setAttribute('id', labelForText);
// 				label.setAttribute('id', labelID);
// 				// get iframe
// 				let iframe = rtf.querySelector('iframe');
// 				iframe.setAttribute('aria-labelledby', labelID);
// 			});
// 		}, 10);
// 	}
// };

const addAriaLive = forms => {
	if (forms) {
		[...forms].forEach(function(form) {
			// setting aria-live on parent div so screen reader can inform user of errors and scussess messages
			form.parentNode.setAttribute('aria-live', 'polite');
		});
	}
};

jQuery(document).on('gform_page_loaded', function(
	event,
	form_id,
	current_page
) {
	let inputs = document.querySelectorAll('li.gf_readonly input');
	setReadonly(inputs);

	// let rtfs = document.querySelectorAll('.ginput_container_textarea');
	// setRichTextTitle(rtfs);
});

let gFormReadOnly = document.querySelectorAll('li.gf_readonly input');
if (gFormReadOnly) {
	setReadonly(gFormReadOnly);
}

let forms = document.querySelectorAll('.gform_wrapper');
if (forms) {
	addAriaLive(forms);
}
